import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';

import { GET_CLIENTS, GET_CLIENTS_SUCCESS, GET_CLIENTS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getClients({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/clients`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CLIENTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CLIENTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CLIENTS_ERROR, payload: error });
  }
}

export function* watchGetCients() {
  yield takeEvery(GET_CLIENTS, getClients);
}

function* getClientsSaga() {
  yield all([fork(watchGetCients)]);
}

export default getClientsSaga;
